module.exports = global["jQuery"] = require("-!/opt/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/jquery/dist/jquery.js
// module id = 8
// module chunks = 0